import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Actions } from '../../Action';
// import Select from 'react-select';
import { bindActionCreators } from 'redux';
import { Select } from 'antd';

/* Months duration component for Questions Searched/Submitted/Answered */
export default function SelectComponentMonthsDuration() {
	const userState = useSelector((state) => state.user);
	const expertOverview = useSelector((state) => state.expertOverviewCmReducer);
	const dispatch = useDispatch();
	// expertOverviewCmReducer
	const {getDurationValue,getTotalCount} = bindActionCreators(Actions,dispatch);
    const array1 = [
    { label: 'Last Month', value: null },
    { label: 'Last 3 Months', value: '3months' }
    ,{ label: 'Last 6 months', value: '6months' },
    { label: 'Last 1 Year', value: '12months' },
    { label: 'Year To Date', value: '-1months' }
    ]

	const customStyles = {
		control: (base,state) => ({
		  ...base,
		  fontSize: 13,
		  marginBottom:5,
		  minHeight:32,
		  height:32,
		  borderColor:state.isFocused ? 'none' : null,
          minWidth:120,
          border: '1px solid lightgrey',
		  boxShadow: 'none',
		  border: state.isFocused ? '1px solid lightgrey' : '1px solid lightgrey',
		  "&:hover":{border:'1px solid lighgrey'}
		}),
		menuList : (base) => ({
			...base,
            fontSize: 13,
			padding:0
		}),
		option: (base,state) => ({
			...base,
			backgroundColor: (state.isSelected && 'var(--viz_light_color)'),
			"&:hover":{backgroundColor: state.isSelected ? null: '#ececec'},
			cursor:'pointer'
		}),
		dropdownIndicator: (styles) => ({
			...styles,
			paddingTop: 0,
			paddingBottom: 0,
			color: "lightgray",
		  }),
		  clearIndicator: (styles) => ({
			...styles,
			paddingTop: 0,
			paddingBottom: 0,
			color: "lightgray",
		  }),
	  };

	  const onChangeData = (data) => {

		getDurationValue(data)
        // getTotalCount()
	  }
	return (
		<>
			{/* <Select
				className="basic-single"
				classNamePrefix="select"
				defaultValue={array1[0]}
				isDisabled={false}
				isClearable={false}
				isSearchable={true}
				name="color"
				options={array1}
				styles={customStyles}
				onChange={onChangeData}
			/> */}
			<Select value={expertOverview.duration} style={{width:'100%'}} options={array1} defaultValue={array1[0]} onChange={onChangeData} labelInValue />
		</>
	)
}